import "@/App.css";
import Starfield from "@/components/Starfield";
import { TabNavigation } from "@/components/TabNavigation";
import { BrokerSection } from "@/components/BrokerSection";
import { TelegramSection } from "@/components/sections/TelegramSection";
import { MentorshipSection } from "@/components/sections/MentorshipSection";
import { PropfirmSection } from "@/components/sections/PropfirmSection";
import { YoutubeSection } from "@/components/sections/YoutubeSection";
import { SocialSection } from "@/components/sections/SocialSection";
import { LOGO_URL } from "@/data/content";
import { useHashTab } from "@/hooks/useHashTab";

const STAR_COUNT = 275;
const SHOOTING_STAR_FREQUENCY = 1.5;

function App() {
  const [activeTab, handleTabChange] = useHashTab();

  return (
    <div className="min-h-screen text-white relative overflow-hidden">
      {/* Fond étoilé animé (canvas, z-index -1, n'affecte ni clics ni lisibilité) */}
      <Starfield starCount={STAR_COUNT} opacity={1} shootingStarFrequency={SHOOTING_STAR_FREQUENCY} />

      {/* Texture overlay */}
      <div className="grain-overlay"></div>
      
      {/* Header */}
      <header className="relative z-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex items-center justify-between mb-8">
            <div className="flex items-center gap-4">
              <img 
                src={LOGO_URL} 
                alt="700S ICT Logo" 
                className="w-16 h-16 sm:w-20 sm:h-20 rounded-full border-2 border-white shadow-glow"
                data-testid="logo-image"
              />
              <h1 className="text-3xl sm:text-5xl font-bold tracking-tight" data-testid="site-title">
                700S ICT
              </h1>
            </div>
          </div>

          {/* Navigation Tabs */}
          <TabNavigation activeTab={activeTab} onChange={handleTabChange} />
        </div>
      </header>

      {/* Main Content */}
      <main className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        
        {/* Telegram Section */}
        {activeTab === "telegram" && <TelegramSection />}

        {/* Mentorship Section */}
        {activeTab === "mentorship" && <MentorshipSection />}

        {/* PropFirm Section */}
        {activeTab === "propfirm" && <PropfirmSection />}

        {activeTab === "broker" && <BrokerSection />}

        {/* YouTube Section */}
        {activeTab === "youtube" && <YoutubeSection />}

        {/* Social Media Section */}
        {activeTab === "social" && <SocialSection />}
      </main>

      {/* Footer */}
      <footer className="relative z-10 mt-20 border-t border-white/10 py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white/60">
          <p data-testid="footer-text">© {new Date().getFullYear()} 700S ICT - Tous droits réservés</p>
        </div>
      </footer>
    </div>
  );
}

export default App;
